import { render } from "./VitShare.vue?vue&type=template&id=89b1ae76&ts=true"
import script from "./VitShare.vue?vue&type=script&lang=ts"
export * from "./VitShare.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__